export default __webpack_public_path__ + "static/media/arrow-neutral.8742f32a.svg";